module.exports = __webpack_public_path__ + "static/media/vf_mwallet_core.28bf926a.svg";